(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-ratgeber"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Größen-Finder über der Maßtabelle: Maße des Geschenks eingeben → passende Zeilen markieren (mind. 1 cm Luft je Maß,
    // Geschenk darf gedreht werden). Die Tabelle selbst bleibt unverändert lesbar.
    var ZUGABE = 1;
    function zahl(s) { return parseFloat(String(s).replace(',', '.')); }
    function masse(text) {
      var re = /(\d+(?:[.,]\d+)?)\s*[×x]\s*(\d+(?:[.,]\d+)?)\s*[×x]\s*(\d+(?:[.,]\d+)?)/g, m, letzte = null;
      while ((m = re.exec(text))) letzte = m;
      if (!letzte) return null;
      return { d: [zahl(letzte[1]), zahl(letzte[2]), zahl(letzte[3])].sort(function (a, b) { return b - a; }), text: letzte[0] };
    }
    function start(wurzel) {
      var t = wurzel.querySelector('table.pp-masstabelle');
      if (!t || t.getAttribute('data-pp-finder')) return;
      t.setAttribute('data-pp-finder', '1');
      var zeilen = [];
      Array.prototype.forEach.call(t.tBodies[0].rows, function (tr) {
        var m = tr.cells[1] ? masse(tr.cells[1].textContent) : null;
        if (m) zeilen.push({ tr: tr, d: m.d, v: m.d[0] * m.d[1] * m.d[2], name: tr.cells[0].textContent.trim(), masse: m.text });
      });
      if (!zeilen.length) return;
      var box = document.createElement('div');
      box.className = 'pp-finder';
      var namen = ['Länge', 'Breite', 'Höhe'];
      box.innerHTML = '<p class="pp-finder__titel"><strong>Größen-Finder:</strong> Geben Sie die Maße Ihres Geschenks in cm ein – passende Kartons werden in der Tabelle markiert.</p>' +
        '<div class="pp-finder__felder">' + namen.map(function (n) { return '<label><span>' + n + '</span><input type="text" inputmode="decimal" autocomplete="off" placeholder="cm" aria-label="' + n + ' in cm"></label>'; }).join('<span class="pp-finder__mal" aria-hidden="true">×</span>') +
        '</div>' +
        '<p class="pp-finder__ergebnis" aria-live="polite"></p>' +
        '<div class="pp-finder__aktionen" hidden><label class="pp-finder__nur"><input type="checkbox"> nur passende Kartons zeigen</label>' +
        '<button type="button" class="pp-finder__leeren">Eingaben löschen</button></div>';
      var rahmen = t.parentNode && t.parentNode.classList.contains('pp-tabelle-rahmen') ? t.parentNode : t;
      rahmen.parentNode.insertBefore(box, rahmen);
      var felder = Array.prototype.slice.call(box.querySelectorAll('.pp-finder__felder input'));
      var ergebnis = box.querySelector('.pp-finder__ergebnis');
      var aktionen = box.querySelector('.pp-finder__aktionen');
      var nurBox = box.querySelector('.pp-finder__nur'), nur = nurBox.querySelector('input');
      var leeren = box.querySelector('.pp-finder__leeren');
      function zuruecksetzen() {
        zeilen.forEach(function (z) { z.tr.classList.remove('pp-passt', 'pp-passt-best', 'pp-passt-nicht'); });
        t.classList.remove('pp-nur-passende');
        nurBox.hidden = true;
      }
      function pruefen() {
        var werte = felder.map(function (f) { return zahl(f.value); });
        aktionen.hidden = !felder.some(function (f) { return f.value.trim() !== ''; });
        if (werte.some(function (x) { return !(x > 0); })) { zuruecksetzen(); ergebnis.textContent = ''; return; }
        var g = werte.slice().sort(function (a, b) { return b - a; }).map(function (x) { return x + ZUGABE; });
        var passend = zeilen.filter(function (z) { return z.d[0] >= g[0] && z.d[1] >= g[1] && z.d[2] >= g[2]; })
          .sort(function (a, b) { return a.v - b.v; });
        zeilen.forEach(function (z) {
          var p = passend.indexOf(z) > -1;
          z.tr.classList.toggle('pp-passt', p);
          z.tr.classList.toggle('pp-passt-nicht', !p);
          z.tr.classList.remove('pp-passt-best');
        });
        if (passend.length) {
          passend[0].tr.classList.add('pp-passt-best');
          ergebnis.innerHTML = '<strong>' + passend.length + (passend.length === 1 ? ' Karton passt' : ' Kartons passen') + '</strong> (mit mindestens 1 cm Luft je Maß). Am knappsten: <strong>' +
            passend[0].name.replace(/</g, '&lt;') + '</strong> (' + passend[0].masse + ' cm).';
          nurBox.hidden = false;
        } else {
          ergebnis.textContent = 'Kein Karton aus der Tabelle ist groß genug. Rufen Sie uns an – wir suchen gern eine Lösung.';
          nurBox.hidden = true;
        }
        t.classList.toggle('pp-nur-passende', nur.checked && passend.length > 0);
      }
      felder.forEach(function (f) { f.addEventListener('input', pruefen); });
      nur.addEventListener('change', pruefen);
      leeren.addEventListener('click', function () { felder.forEach(function (f) { f.value = ''; }); nur.checked = false; pruefen(); felder[0].focus(); });
    }
    function alle() { Array.prototype.forEach.call(document.querySelectorAll('[data-pp-rg]'), start); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
    document.addEventListener('shopify:section:load', alle);
  })();

  } catch(e) { console.error(e); }
})();
})();
